import { httpClient } from '@/shared/services/http-client'

export const benchmarkData = {
  namespaced: true,
  state: {
    benchmarkStructureData: null,
    benchmarkChartsData: null,
    benchmarkSchoolFilterOptionsData: null,
    benchmarkSchoolFilterValuesData: null,
    benchmarkComparableSchools: null
  },
  mutations: {
    setBenchmarkStructureData(state: any, data: any) {
      state.benchmarkStructureData = data
    }
  },
  actions: {
    async getBenchmarkStructureData(context: any) {
      const url = `benchmark`;
      const body = {
        query: `
            query{
                acaraBenchmarkQuery{
                  datasets{
                    label
                    value
                    metrics{
                      label
                      value
                      model
                      field
                      subMetrics{
                        label
                        value
                        field
                      }
                    }
                  }
                }
              }
            `,
        variables: {},
      }

      const benchmarkStructureData = await httpClient.post(url, body);

      if (benchmarkStructureData["data"]["data"]["acaraBenchmarkQuery"]['datasets'] !== null) {
        context.commit('setBenchmarkStructureData', benchmarkStructureData["data"]["data"]["acaraBenchmarkQuery"]['datasets'])
      }
    }
  }
}